module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00305.8fb833db.jpg";